export type LicenseLevel = "standard" | "enterprise";
export type LicensedFeature = "import_apply" | "execution_history" | "workspace" | "report_pdf";

const rawLicense = String(import.meta.env.VITE_LICENSE ?? "").toLowerCase();
const legacyEdition = String(import.meta.env.VITE_APP_EDITION ?? "education").toLowerCase();

export const APP_LICENSE: LicenseLevel = rawLicense === "enterprise" || legacyEdition === "enterprise" ? "enterprise" : "standard";

const FEATURE_LEVEL: Record<LicensedFeature, LicenseLevel> = {
  import_apply: "enterprise",
  execution_history: "enterprise",
  workspace: "enterprise",
  report_pdf: "standard",
};

export function hasFeature(feature: LicensedFeature, license: LicenseLevel = APP_LICENSE) {
  return license === "enterprise" || FEATURE_LEVEL[feature] === "standard";
}
